import { useScreenSize } from "../../../hooks/useScreenSize";
import AdminLayout from "../Attachments/AdminLayout";
import AnnouncementsList from "./AnnouncementsList";
import PublishablePreview from "../../../components/PublishablePreview";

export default function AdminAnnouncementsIndex({
  announcements,
  'previewed_announcement': previewedAnnouncement = {},
  query = ''
}: any) {
  const { screenLargerThan } = useScreenSize()

  return (
    <AdminLayout>
      <div style={{
        display: 'flex',
        flexDirection: screenLargerThan('md') ? 'row' : 'column',
        gap: '8px',
        flex: 1,
        minHeight: 0,
      }}>
        <div style={{
          flex: 1,
          overflowX: 'hidden',
          backgroundColor: '#ddd'
        }}>
          <AnnouncementsList
            announcements={announcements}
            previewedAnnouncement={previewedAnnouncement}
            searchQuery={query}
          />
        </div>
        <div style={{
          flex: 2,
          minHeight: 0,
          overflow: 'hidden'
        }}>
          <PublishablePreview
            key={`announcement-preview-${previewedAnnouncement?.id || 'new'}`}
            publishable={previewedAnnouncement ? previewedAnnouncement : {}}
            frontendViewPath={`/announcements/${previewedAnnouncement?.id}`}
            recordKind="announcement"
            path="/admin/announcements"
          />
        </div>
      </div>
    </AdminLayout>
  )
}